export const testimonials = [
  {
    id: 1,
    name: 'Ahmed Hassan',
    role: 'Overseas Investor',
    location: 'Dubai, UAE',
    text: 'Sunshine Real Estate made my investment journey incredibly smooth from Dubai. Their team handled everything remotely — from documentation to booking. I now own a 10 Marla plot in Islamabad E-19 and the appreciation has been outstanding.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20middle%20eastern%20man%20in%20business%20attire%20warm%20natural%20lighting%20clean%20background%20high%20quality&width=200&height=200&seq=201&orientation=squarish',
  },
  {
    id: 2,
    name: 'Fatima Ali',
    role: 'First-Time Buyer',
    location: 'Lahore, Pakistan',
    text: 'As a first-time real estate investor, I was nervous. But Sunshine guided me every step of the way. Their transparency and patience gave me confidence. I booked a 5 Marla plot and the process was flawless.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20confident%20Pakistani%20woman%20in%20elegant%20attire%20soft%20natural%20lighting%20clean%20background&width=200&height=200&seq=202&orientation=squarish',
  },
  {
    id: 3,
    name: 'Muhammad Farooq',
    role: 'Business Owner',
    location: 'Karachi, Pakistan',
    text: 'I have dealt with many property dealers, but Sunshine Real Estate stands apart. Their project marketing expertise and investment guidance helped me diversify my portfolio. Highly recommended for serious investors.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20mature%20South%20Asian%20businessman%20in%20formal%20attire%20warm%20lighting%20studio%20background&width=200&height=200&seq=203&orientation=squarish',
  },
  {
    id: 4,
    name: 'Sana Tariq',
    role: 'Repeat Investor',
    location: 'Islamabad, Pakistan',
    text: 'This is my third investment with Sunshine. Each time, the process gets better. Their site visit support and documentation assistance is unmatched. They truly care about their clients\' financial growth.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20young%20professional%20Pakistani%20woman%20modern%20style%20soft%20lighting%20neutral%20background&width=200&height=200&seq=204&orientation=squarish',
  },
  {
    id: 5,
    name: 'Kamran Shah',
    role: 'Commercial Investor',
    location: 'Rawalpindi, Pakistan',
    text: 'Sunshine helped me identify a prime commercial plot that has already appreciated 40% in under a year. Their market insight and honest advice are what every investor needs.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20middle%20aged%20Pakistani%20man%20in%20casual%20business%20attire%20nice%20smile%20natural%20lighting&width=200&height=200&seq=205&orientation=squarish',
  },
];